<template>
  <div class="container">
    <div class="card">
        <div> 
          <router-link to="/">
            <img alt="back" src="../../assets/back-primary.svg" class="card-img"/>
          </router-link>
          <span class="card-title">
              Password
          </span>
        </div> 
        <b-form @submit="submit" class="input">
          <b-form-input
            id="username"
            v-model="username"
            type="text"
            required
            placeholder="Nome utente"
          ></b-form-input>
          <b-form-input
            id="password"
            v-model="password"
            type="password"
            required
            placeholder="Password"
          ></b-form-input>
        
          <div class="button">
            <b-button block type="submit" variant="success">Accedi</b-button>
          </div>
        </b-form>
    </div>
  </div>
  
</template>

<script>

export default {
  name: "LoginLab",
  data () {
    return {
      password: "",
      username: ""
    }
  },
  methods: {
    submit: function(evt){
      evt.preventDefault()
      this.$axios.post( this.$apibase + '/auth/obtain_token/', 
      {        
          'username': this.username,
          'password': this.password
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(
        (response) => {
          localStorage.setItem('access_token', response.data.token);
          let user = {
            'full_name': this.username,
            'user_type': ['labs']
          }
          this.$store.dispatch("setUser", user);
          window.dispatchEvent(new CustomEvent('setUsername'));
          this.$router.push('/dashboard-lab');
        }
      )
      .catch(()=>{
        this.$store.dispatch('setAlert', {message: "La combinazione di username e password è incorretta.", type: 'danger'});
      })
    }
  }
};
</script>

<style scoped>
  .container {
    text-align: center;
    padding-top: 100px;
  }
  .card{    
    width: 400px;
    display: inline-flex;
    height: 390px;
    box-shadow: 0 0 5px #6abf61;
    padding: 80px 50px;
    text-align: center;
    align-items: center;    
  }
  .card-title{
    font-size: 21px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
  }
  .card-img{
    width:30px;
    float: left;
  }
  .input{
    padding-top: 40px;
    width: 100%;
  }
  .button {
    padding-top: 20px;
    width: 100%;
  }
</style>